import { Common, ApiBind } from './common.model';

export class Passback extends Common {

  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'is_emergency_stop' })
  isEmergencyStop: boolean;
}
